import { createApp } from 'vue'
import {createRouter,createWebHashHistory} from 'vue-router'
import ElementPlus from 'element-plus' // 引入element-plus
import 'element-plus/theme-chalk/index.css' // 引入element-plus的样式
import zhCn from 'element-plus/dist/locale/zh-cn'
import vfocus from './commom/v-cmd/v-input-focus'




import App from './App.vue'
import routes from './routes'

import * as echarts from 'echarts/core';
import { LineChart } from 'echarts/charts';
import {
  TitleComponent,
  TooltipComponent,
  GridComponent,
  ToolboxComponent,
  LegendComponent,
} from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';

echarts.use([
  LineChart,
  TitleComponent,
  TooltipComponent,
  GridComponent,
  ToolboxComponent,
  LegendComponent,
  CanvasRenderer,
]);


const router =  createRouter({
    // 4. 内部提供了 history 模式的实现。为了简单起见，我们在这里使用 hash 模式。
    history:  createWebHashHistory(),//createWebHashHistory(),
    routes, // `routes: routes` 的缩写
})

const app = createApp(App)
app.use(ElementPlus, { zIndex: 3000, size: 'middle' ,locale:zhCn})
app.use(router)
app.config.globalProperties.$echarts = echarts;





vfocus.register(app)



app.mount('#app')

// 渐隐移除 loading
const loading = document.getElementById('global-loading');
if (loading) {
  loading.style.opacity = '0';
  loading.style.transition = 'opacity 0.5s';
  setTimeout(() => {
    loading.parentNode.removeChild(loading);
  }, 500);
}
